"use strict";

// We override loadPage & loadPagesync to fix canonical redirects
// we also override hovering to disable hover prefetch
exports.onClientEntry = function () {
  var loader = window.___loader; // if development or no loader exists we shouldn't do anything

  if (process.env.NODE_ENV === 'development' || !loader) {
    return;
  }

  var pagePath = window.pagePath;
  var location = window.location;

  if (pagePath && pagePath !== location.pathname && pagePath !== location.pathname + '/') {
    var originalLoadPageSync = loader.loadPageSync;
    var originalLoadPage = loader.loadPage;

    loader.loadPageSync = function (path) {
      var pageResources; // if the path is the same as our current page we know it's not a prefetch

      if (path === location.pathname) {
        pageResources = originalLoadPageSync(pagePath);
      } else {
        pageResources = originalLoadPageSync(path);
      }

      if (pageResources.page) {
        pageResources.page.matchPath = '*';
      }

      return pageResources;
    };

    loader.loadPage = function (path) {
      var pageResources; // if the path is the same as our current page we know it's not a prefetch

      if (path === location.pathname) {
        pageResources = originalLoadPage(pagePath);
      } else {
        pageResources = originalLoadPage(path);
      }

      if (pageResources.page) {
        pageResources.page.matchPath = '*';
      }

      return pageResources;
    };
  } // disable hovering prefetching as we don't know if we can.


  loader.hovering = function () {};
}; // we also need to disable prefetching as we don't know the exact page-data path.
// TODO look at prefetch a whole html page on hover?


exports.disableCorePrefetching = function () {
  return true;
};